module['exports'] = ['ہیچ بیک', 'سواری'];
